import { render, staticRenderFns } from "./ProductFinder.vue?vue&type=template&id=48f9c48e&scoped=true"
import script from "./ProductFinder.vue?vue&type=script&lang=js"
export * from "./ProductFinder.vue?vue&type=script&lang=js"
import style0 from "./ProductFinder.vue?vue&type=style&index=0&id=48f9c48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f9c48e",
  null
  
)

export default component.exports